import { render, staticRenderFns } from "./PageNotFound.vue?vue&type=template&id=a9e2b96e&scoped=true&"
import script from "./PageNotFound.vue?vue&type=script&setup=true&lang=js&"
export * from "./PageNotFound.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./PageNotFound.vue?vue&type=style&index=0&id=a9e2b96e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9e2b96e",
  null
  
)

export default component.exports